<template>
  <div>
    <DxPopup
      :visible="visible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :showTitle="true"
      :show-title="true"
      :title="gcSundryTransactionPopupConfig.title"
      :width="'90%'"
      :height="'720'"
      @hidden="onPopupHide"
      @shown="onShown"
      :showCloseButton="false"
      :class="'sundry-transaction-model'"
      :titleTemplate="
        gcSundryTransactionPopupConfig.title ? undefined : 'titleTemplate'
      "
      :wrapperAttr="{ class: 'css-v2 gc-popup sundry-transaction-model' }"
    >
      <template #titleTemplate>
        <div class="title-container">
          <div v-if="popUpScreenOptions()">
            <DxSelectBox
              :items="popUpScreenOptions()"
              valueExpr="value"
              displayExpr="text"
              :onValueChanged="popUpScreenChangeCallback"
              :value="
                selectedScreen
                  ? selectedScreen
                  : popUpScreenOptions().find(
                      (element) => element.isDefault === true,
                    ).value
              "
              :drop-down-options="{ width: 250 }"
            >
            </DxSelectBox>
          </div>
          <div
            v-if="isBankAccountSelectionRequired"
            class="bank-account-selector"
          >
            <DxSelectBox
              ref="bankAccountSelectBox"
              :items="bankAccountDataSource"
              valueExpr="Code"
              displayExpr="AccountName"
              placeholder="Select Bank Account"
              :onValueChanged="onBankAccountChanged"
              :value="selectedBankAccountCode"
              :drop-down-options="{ width: 280 }"
              :width="200"
              :show-clear-button="true"
              :search-enabled="true"
            >
            </DxSelectBox>
          </div>
          <div
            class="custom-title"
            v-if="gcSundryTransactionPopupConfig.titleLines"
          >
            <div
              class="title-primary"
              v-for="popupTitleLine in gcSundryTransactionPopupConfig.titleLines"
              :key="popupTitleLine"
            >
              {{ popupTitleLine }}
            </div>
          </div>
          <div class="custom-title" v-else-if="!popupTitle">
            <span class="title-primary">{{ popupTitles.primary }}</span>
            <span class="title-secondary"> {{ popupTitles.secondary }}</span>
          </div>
          <div class="custom-title" v-else>
            <span class="title-primary">{{ popupTitle }}</span>
          </div>
        </div>
      </template>
      <DxScrollView
        id="scrollview"
        ref="scrollViewWidget"
        :scroll-by-content="true"
        :scroll-by-thumb="true"
        :show-scrollbar="'onScroll'"
      >
        <div>
          <div class="header-form css-v2 gc-popup-form">
            <gc-form
              :formOptions="formOptions"
              :formItems="formItems"
              :formHeight="'auto'"
              :isNormal="true"
              :data-model="dataModel"
              :formMode="baseView.mode"
              :validationGroup="'gc-popup-form-data'"
              :formTitle="'gc-popup'"
              v-if="formItems && loaded"
              :checkValid="isValid"
              :ref="'sundry-transaction-data-form'"
              :formContentReady="onFormContentReady"
              :valueChangeCallBack="valueChangeCallBack"
              :key="formKey"
            >
              <template #supplier="{ data }">
                <div class="custom-auto-complete">
                  <span class="auto-complete-primary">{{ data.Name }}</span>
                  <span class="auto-complete-secondary">{{ data.Code }}</span>
                </div>
              </template>
            </gc-form>
          </div>

          <div class="css-v2 gc-popup-data-grid">
            <dx-data-grid
              v-if="loaded"
              :height="selectedScreen == 'new-sundry-payment' ? 400 : 340"
              :row-alternation-enabled="true"
              :columnChooser="{
                enabled: false,
              }"
              :pager="{ visible: false }"
              :column-auto-width="false"
              :columns="getColumns"
              :data-source="getDataSource"
              @editor-preparing="onEditorPreparing"
              :ref="dataGridRef"
              @saved="onSaved"
              @row-removed="onRowRemoved"
              keyExpr="ID"
            >
              <DxEditing
                :allow-updating="true"
                :allow-deleting="false"
                mode="cell"
                :new-row-position="'last'"
                :confirm-delete="false"
                :changes="changes"
              />
            </dx-data-grid>
          </div>

          <div class="footer-form">
            <gc-form
              :formOptions="formOptions"
              :formItems="footerFormItems"
              :formHeight="'auto'"
              :isNormal="true"
              :data-model="dataModel"
              :formMode="baseView.mode"
              :validationGroup="'gc-popup-form-data'"
              :formTitle="'gc-popup'"
              v-if="formItems && loaded"
              :checkValid="isValidFooter"
            ></gc-form>
          </div>

          <div class="footer" v-if="loaded">
            <DxButton
              class="save-btn"
              text="Save"
              type="default"
              styling-mode="contained"
              @click="onClickSave"
              :disabled="handleSaveVisibility()"
            />
            <DxButton
              text="Cancel"
              type="default"
              styling-mode="contained"
              @click="popupHidden"
            />
          </div>
        </div>
      </DxScrollView>
    </DxPopup>
  </div>
</template>
<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { JournalDetailServices } from "../_services/api/finance/journalDetail";
import { DivisionService } from "../_services/api/sales/division.service";
import { BranchService } from "../_services/api/sales/branch.service";
import { ProductService } from "../_services/api/products/product.service";
import { CompanyService } from "../_services/api/accounts/company.service";
import { getFactorByCode } from "../_store/helpers";
import { getDefaultUserSettings } from "../_store/helpers";
import { BankAccountTransactionServices } from "../_services/api/finance/bank-account-transaction.service";
import { BankAccountsServices } from "../_services/api/finance/bankAccounts";
import { SupplierService } from "../_services/api/suppliers/supplier.service";
import { CustomerService } from "../_services/api/customers/customer.service";
import { ForeignCurrencyService } from "../_services/api/settings/accounting/foreign-currency.service";
import { FxToBaseCurrency } from "../_helpers/formulas/sales-formulas";
import ArrayStore from "devextreme/data/array_store";

import DataGridHelpers from "@/_helpers/data-grid/helpers";
import ColumnWidth from "../_helpers/data-grid/ColumnWidth";
import { backwardTabbing, forwardTabbing } from "../_helpers/ui/keyboard";
import { mapGetters } from "vuex";
const { countLineBreaks } = DataGridHelpers;

let baseLine = {
  GLChartCode: undefined,
  GLChartDescription: undefined,
  BranchCode: undefined,
  BranchDescription: undefined,
  DivisionCode: undefined,
  DivisionDescription: undefined,
  Comment: "",
  Amount: 0,
  FxAmount: 0,
};

export default {
  props: {
    titleTemplate: {
      type: String,
      default: null,
    },
    visible: Boolean,
    gcSundryTransactionPopupConfig: {
      type: Object,
      default: () => {},
    },
    setLoading: {
      type: Function,
      default: function () {},
    },
    showValidationSummary: {
      type: Function,
      default: function () {},
    },
    popupTitle: {
      type: String,
      default: null,
    },
    popupTitles: {
      type: Object,
      default: () => ({
        primary: "",
        secondary: "",
      }),
    },
  },
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  data() {
    return {
      isPopupHiddenBySave: false,
      isPopupHiddenByCancel: false,
      selectedScreen: undefined,
      formOptions: {
        gcLabelLocation: "left",
      },
      dataModel: {
        SundryPaymentDate: new Date(),
        SundryPaymentPayeeName: undefined,
        SundryPaymentAmount: undefined,
        SundryPaymentTax: 0.0,
        SundryPaymentBASReportable: true,
        SundryPaymentSupplierCode: undefined,
        FxSundryPaymentSubTotal: 0,
        SundryPaymentTotal: 0,
        FxSundryPaymentTotal: 0,

        FxSundryPaymentAmount: 0,
        FxSundryPaymentTax: 0.0,

        SundryReceiptDate: new Date(),
        SundryReceiptPayer: undefined,
        SundryReceiptCustomerCode: undefined,
        SundryReceiptPaymentMethod: undefined,
        SundryReceiptBranch: undefined,
        SundryReceiptDivision: undefined,
        SundryReceiptAmount: undefined,
        FxSundryReceiptAmount: 0.0,
        SundryReceiptTax: 0.0,
        FxSundryReceiptTax: 0.0,
        SundryReceiptBASReportable: true,
        SundryReceiptSubTotal: 0,
        FxSundryReceiptSubTotal: 0,
        SundryReceiptTotal: 0,
        FxSundryReceiptTotal: 0,
        CurrencyCode: undefined,
        ExchangeRate: 1,
        PaymentMethods: [],
        Narration: undefined,
        DefaultComment: false,
      },
      minDate: undefined,
      maxDate: undefined,
      currencyCode: undefined,
      localDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      glChartDataSourceItems: [],
      branchDataSourceItems: [],
      divisionDataSourceItems: [],
      defaultBranchCode: undefined,
      defaultDivisionCode: undefined,
      isValid: false,
      isValidFooter: false,
      loaded: false,
      gridOptions: {
        dxScrolling: "standard",
      },
      disabledSave: true,
      gridKey: 0,
      loadItems: false,
      validationSummary: [],
      visibleAddNew: true,

      dataGridRef: "gc-sundry-data-grid",
      changes: [],
      headerFormInstance: undefined,
      isEditingPayerField: false,
      bankAccountDataSource: [],
      selectedBankAccountCode: undefined,
      selectedBankAccount: undefined,
      supplierListOptions: [],
      customerListOptions: [],
      formKey: 0,
      selectedBankCurrency: undefined,
    };
  },
  async created() {},
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    isBankAccountSelectionRequired() {
      return !this.gcSundryTransactionPopupConfig.dataModel.BankAccountCode;
    },
    resolvedBankAccountCode() {
      return this.gcSundryTransactionPopupConfig.dataModel.BankAccountCode
        ? this.gcSundryTransactionPopupConfig.dataModel.BankAccountCode
        : this.selectedBankAccount
        ? this.selectedBankAccount.Code
        : undefined;
    },
    resolvedBSBNO() {
      return this.gcSundryTransactionPopupConfig.dataModel.BSBNO
        ? this.gcSundryTransactionPopupConfig.dataModel.BSBNO
        : this.selectedBankAccount
        ? this.selectedBankAccount.BsbNo
        : undefined;
    },
    resolvedAccountNo() {
      return this.gcSundryTransactionPopupConfig.dataModel.AccountNo
        ? this.gcSundryTransactionPopupConfig.dataModel.AccountNo
        : this.selectedBankAccount
        ? this.selectedBankAccount.AccountNo
        : undefined;
    },
    formItems() {
      if (this.isSundryPaymentScreen())
        return this.populateSundryPaymentHeader().items;
      else return this.populateSundryReceiptHeader().items;
    },
    footerFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: this.getFooterFormItems.filter((x) => x.visible != false)
            .length,
          items: this.getFooterFormItems.filter((x) => x.visible != false),
        },
      ];
    },
    getFooterFormItems() {
      return [
        {
          screenField: "FXTotal",
          dataField: this.isSundryPaymentScreen()
            ? "FxSundryPaymentSubTotal"
            : "FxSundryReceiptSubTotal",
          location: "left",
          label: {
            text: `Sub Total(${this.dataModel.CurrencyCode})`,
          },
          format: "Decimal-16-4C",
        },
        {
          dataField: this.isSundryPaymentScreen()
            ? "FxSundryPaymentTax"
            : "FxSundryReceiptTax",
          screenField: "FXTotal",
          location: "right",
          value: 0,
          label: {
            text: `Tax (${this.dataModel.CurrencyCode})`,
          },
          format: "Decimal-16-4C",
        },
        {
          dataField: this.isSundryPaymentScreen()
            ? "FxSundryPaymentTotal"
            : "FxSundryReceiptTotal",
          screenField: "FXTotal",
          location: "right",

          label: {
            text: `Total (${this.dataModel.CurrencyCode})`,
          },
          format: "Decimal-16-4C",
        },
        {
          dataField: this.isSundryPaymentScreen()
            ? "SundryPaymentTotal"
            : "SundryReceiptTotal",
          screenField: "FXTotal",
          location: "right",

          label: {
            text: `Total (${this.currencyCode})`,
          },
          format: "Decimal-16-4C",

          visible: this.dataModel.CurrencyCode != this.currencyCode,
        },
      ];
    },

    getColumns() {
      if (this.isSundryPaymentScreen()) {
        return this.getSundryPaymentColumns();
      } else return this.getSundryReceiptColumns();
    },

    getDataSource() {
      return this.localDataSource._array;
    },

    getGridInstance() {
      if (this.$refs[this.dataGridRef])
        return this.$refs[this.dataGridRef].instance;
      else return null;
    },

    getSupplierFilter() {
      if (this.selectedBankCurrency) {
        if (this.selectedBankCurrency != this.currencyCode) {
          return [
            ["CurrencyCode", "=", `${this.selectedBankCurrency}`],
            "and",
            ["Inactive", "=", "N"],
          ];
        } else {
          return [["Inactive", "=", "N"]];
        }
      } else {
        return this.gcSundryTransactionPopupConfig.dataModel.FXCurrency &&
          this.gcSundryTransactionPopupConfig.dataModel.FXCurrency !=
            this.currencyCode
          ? [
              [
                "CurrencyCode",
                "=",
                `${this.gcSundryTransactionPopupConfig.dataModel.FXCurrency}`,
              ],
              "and",
              ["Inactive", "=", "N"],
            ]
          : [["Inactive", "=", "N"]];
      }
    },
  },
  watch: {
    visible(value) {
      if (value) this.initialized();
    },
    async selectedScreen(value) {
      if (value == "new-sundry-receipt") {
        if (this.dataModel.PaymentMethods.length == 0)
          BankAccountTransactionServices.getPaymentMethods().then(
            ({ data }) => {
              var PaymentMethods = data.value;
              this.dataModel.PaymentMethods = PaymentMethods;
              this.dataModel.SundryReceiptPaymentMethod = data.value.filter(
                (val) => val.isDefault === 1,
              )[0].PayType;
            },
          );
        else {
          this.dataModel.SundryReceiptPaymentMethod =
            this.dataModel.PaymentMethods.filter(
              (val) => val.isDefault === 1,
            )[0].PayType;
        }
      }
    },

    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          this.$nextTick(() => {
            // Trigger validation which will call valueChangeCallBack
            this.isValid = true;
          });
        }
      },
      deep: true,
    },
  },

  methods: {
    /**
     * On Click Save
     */
    onClickSave() {
      // Trigger validation which will call valueChangeCallBack
      this.isValid = true;
    },
    /**
     * Value Change Call Back
     * @param isValid Validation Status
     * @param brokenRules
     */
    async valueChangeCallBack(isValid, brokenRules) {
      var validations = "";

      if (!isValid) {
        brokenRules.forEach((element) => {
          validations += `<div style="width: 400px;">${element.message}</div>`;
        });

        try {
          await this.$alert(validations, "Validation Error", {
            width: 400,
          });
        } catch (error) {
          // User might have pressed ESC, but we still need to reset
        }
      } else {
        const items = await this.localDataSource.load();
        const validLines = items.filter(
          (x) => x.GLChartCode && x.Amount && x.Amount != 0,
        );

        if (validLines.length === 0) {
          await this.$alert(
            "At least one line with valid Account and Amount is required.",
            "Validation Error",
          );
        } else if (
          this.isSundryPaymentScreen() &&
          this.dataModel.SundryPaymentTotal == 0
        ) {
          await this.$alert(
            "Total amount should be greater than 0 to save the transaction.",
            "Validation Error",
          );
        } else if (
          this.isSundryPaymentScreen() &&
          this.dataModel.SundryPaymentAmount !=
            this.dataModel.SundryPaymentTotal
        ) {
          await this.$alert(
            "Header amount should be equal to total of line amounts to save the transaction.",
            "Validation Error",
          );
        } else if (
          !this.isSundryPaymentScreen() &&
          this.dataModel.SundryReceiptTotal == 0
        ) {
          await this.$alert(
            "Total amount should be greater than 0 to save the transaction.",
            "Validation Error",
          );
        } else if (
          !this.isSundryPaymentScreen() &&
          this.dataModel.SundryReceiptAmount !=
            this.dataModel.SundryReceiptTotal
        ) {
          await this.$alert(
            "Header amount should be equal to total of line amounts to save the transaction.",
            "Validation Error",
          );
        } else {
          await this.handleSave(validLines);
        }
      }

      // Always reset isValid after processing
      this.$nextTick(() => {
        this.isValid = false;
      });
    },
    onPopupHide() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
      this.gcSundryTransactionPopupConfig.gcPopupCallBack();
    },
    async onShown() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
      this.setLoading(true);
      await this.initialized();
      if (this.gcSundryTransactionPopupConfig.copySource) {
        await this.applyCopySource();
      }
      this.$nextTick(() => {
        this.loaded = true;
        this.setLoading(false);
      });
    },
    /**
     * Pre-populate the popup from a source transaction (Copy).
     * Date and Default Comment intentionally stay at their fresh-popup
     * defaults (today / unchecked) per BR-2090-4 — nothing to reset here.
     */
    async applyCopySource() {
      const copySource = { ...this.gcSundryTransactionPopupConfig.copySource };
      const header = { ...copySource.header };

      if (
        copySource.screenType === "new-sundry-receipt" &&
        this.dataModel.PaymentMethods.length === 0
      ) {
        await BankAccountTransactionServices.getPaymentMethods().then(
          ({ data }) => {
            this.dataModel.PaymentMethods = data.value;
          },
        );
      }

      this.selectedScreen = copySource.screenType;
      await this.$nextTick();

      this.dataModel.CurrencyCode = header.CurrencyCode || this.currencyCode;
      this.dataModel.ExchangeRate = header.ExchangeRate || 1;
      this.dataModel.Reference = header.Reference;
      this.dataModel.Narration = header.Narration;

      if (copySource.screenType === "new-sundry-payment") {
        this.dataModel.SundryPaymentSupplierCode = header.SupplierCode;
        this.dataModel.SundryPaymentPayeeName = header.PayeeName;
        this.dataModel.SundryPaymentBASReportable = header.IsGstReportable;
        this.dataModel.SundryPaymentTax = header.GSTAmount;
        this.dataModel.FxSundryPaymentTax = header.FXTaxAmount;
      } else {
        this.dataModel.SundryReceiptCustomerCode = header.CustomerCode;
        this.dataModel.SundryReceiptPayer = header.PayeeName;
        this.dataModel.SundryReceiptPaymentMethod = header.PaymentMethod;
        this.dataModel.SundryReceiptBranch = header.BranchCode;
        this.dataModel.SundryReceiptDivision = header.DivisionCode;
        this.dataModel.SundryReceiptBASReportable = header.IsGstReportable;
        this.dataModel.SundryReceiptTax = header.TaxAmount;
        this.dataModel.FxSundryReceiptTax = header.FXTaxAmount;
      }

      this.localDataSource.clear();
      const lines = copySource.lines.length > 0 ? copySource.lines : [{}];
      lines.forEach((line) => {
        this.localDataSource.insert({ ...baseLine, ...line });
      });
      this.$nextTick(() => {
        this.localDataSource.insert({ ...baseLine });
      });

      if (copySource.screenType === "new-sundry-payment") {
        await this.setFxSundryPaymentSubTotal();
        this.dataModel.FxSundryPaymentAmount =
          this.dataModel.FxSundryPaymentTotal;
        this.dataModel.SundryPaymentAmount = this.dataModel.SundryPaymentTotal;
      } else {
        await this.setFxSundryReceiptSubtotal();
        this.dataModel.FxSundryReceiptAmount =
          this.dataModel.FxSundryReceiptTotal;
        this.dataModel.SundryReceiptAmount = this.dataModel.SundryReceiptTotal;
      }

      // if (this.getGridInstance) {
      //   this.getGridInstance.refresh(true);
      // }
    },
    updateColumnValue(dataField, value, rowIndex) {
      const gridInstance = this.getGridInstance;
      if (gridInstance) {
        gridInstance.cellValue(rowIndex, dataField, value);
      }
    },
    getSundryPaymentColumns() {
      return [
        {
          caption: "Account",
          dataField: "GLChartCode",
          width: 200,
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: ProductService.dataSourceConfig("api/GLChart", {
              filter: [
                ["Inactive", "=", "N"],
                "and",
                ["Status", "=", "A"],
                "and",
                ["IsControlAcct", "<>", "Y"],
              ],
              sort: [{ selector: "ComputedStringCode", asc: true }],
              select:
                "Code,ComputedStringCode,Description, Inactive, Status, IsControlAcct,GLAccountSearchText",
            }),
            displayExpr: (e) => {
              if (e) return `${e.Code} - ${e.Description}`;
              else undefined;
            },
            valueExpr: "ComputedStringCode",
            searchExpr: [
              "ComputedStringCode",
              "Description",
              "GLAccountSearchText",
            ],
            searchEnabled: true,
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.Code}" >
                          <span class="auto-complete-primary">
                            ${data.Description}
                          </span>
                          <span class="record-secondary gc-grid-code">
                            ${data.Code}
                          </span>
                        </div>`;
            },
            dropDownOptions: {
              minWidth: 300,
            },
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onValueChanged: (e, cellInfo) => {
              const data = cellInfo.data;
              if (!e || !e.event) return;
              else {
                const instance = e.component;
                const selectedData = instance.option("selectedItem");
                if (selectedData) {
                  // cellInfo.data.GLChartCode = selectedData.ComputedStringCode;
                  cellInfo.data.GLChartDescription = selectedData.Description;

                  this.localDataSource.update(data.ID, {
                    GLChartDescription: selectedData.Description,
                  });

                  this.updateColumnValue(
                    "GLChartCode",
                    selectedData.ComputedStringCode,
                    cellInfo.rowIndex,
                  );
                } else {
                  // cellInfo.data.GLChartCode = undefined;
                  cellInfo.data.GLChartDescription = undefined;
                  this.localDataSource.update(data.ID, {
                    GLChartDescription: undefined,
                  });
                  this.updateColumnValue(
                    "GLChartCode",
                    undefined,
                    cellInfo.rowIndex,
                  );
                }
              }

              this.$nextTick(() => {
                this.focusOnEditableCell(cellInfo.rowIndex, "BranchCode");
              });
            },
            onKeyDown: (e, cellInfo) => {
              if (!e.event) return;
              if (backwardTabbing(e)) {
                if (cellInfo.rowIndex === 0) {
                  e.event.preventDefault();
                  let dataField = "FxSundryPaymentTax";

                  this.$nextTick(() => {
                    this.setFocusOnField(dataField);
                  });
                }
              }
            },
          },
          cssClass: "edit-cell-textbox-field",
          calculateDisplayValue: (e) => {
            if (e.GLChartCode && e.GLChartDescription)
              return e.GLChartCode + " - " + e.GLChartDescription;
            else return "";
          },
          setCellValue: (newData, value, currentRowData) => {
            newData.GLChartCode = value;
            if (!currentRowData.GLChartCode) {
              this.addNextLine(currentRowData, false);
            }

            return newData;
          },
          alignment: "left",
        },
        {
          caption: "Branch",
          dataField: "BranchCode",
          editorType: "dxSelectBox",
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            dataSource: this.branchDataSourceItems,
            displayExpr: (e) => {
              if (e) return `${e.Code} - ${e.Description}`;
              else undefined;
            },
            valueExpr: "Code",
            searchEnabled: true,
            searchExpr: ["Description", "Code"],
            onFocusIn: (e) => {
              e.event.target.select();
            },
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.Code}" >
                          <span class="auto-complete-primary">
                            ${data.Description}
                          </span>
                          <span class="record-secondary gc-grid-code">
                            ${data.Code}
                          </span>
                        </div>`;
            },
            dropDownOptions: {
              minWidth: 150,
            },
          },
          calculateDisplayValue: (e) => {
            if (e.BranchCode)
              return (
                e.BranchCode +
                " - " +
                this.branchDataSourceItems.find((x) => x.Code === e.BranchCode)
                  .Description
              );
            else return "";
          },
          setCellValue: (newData, value) => {
            newData.BranchCode = value;

            return newData;
          },
          width: ColumnWidth.BranchDescription.width,
          minWidth: ColumnWidth.BranchDescription.minWidth,
        },
        {
          caption: "Division",
          dataField: "DivisionCode",
          editorType: "dxSelectBox",
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            dataSource: this.divisionDataSourceItems,
            displayExpr: (e) => {
              if (e) return `${e.Code} - ${e.Description}`;
              else return undefined;
            },
            valueExpr: "Code",
            searchEnabled: true,
            searchExpr: ["Description", "Code"],
            onFocusIn: (e) => {
              e.event.target.select();
            },
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.Code}" >
                          <span class="auto-complete-primary">
                            ${data.Description}
                          </span>
                          <span class="record-secondary gc-grid-code">
                            ${data.Code}
                          </span>
                        </div>`;
            },
            dropDownOptions: {
              minWidth: 150,
            },
          },
          calculateDisplayValue: (e) => {
            if (e.DivisionCode)
              return (
                e.DivisionCode +
                " - " +
                this.divisionDataSourceItems.find(
                  (x) => x.Code === e.DivisionCode,
                ).Description
              );
            else return "";
          },
          setCellValue: (newData, value) => {
            newData.DivisionCode = value;

            return newData;
          },
          width: ColumnWidth.DivisionDescription.width,
          minWidth: ColumnWidth.DivisionDescription.minWidth,
        },
        {
          caption: "Comments",
          dataField: "Comment",
          editorType: "dxTextArea",
          cssClass: "edit-cell-textbox-field comment-text",
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
          allowEditing: true,
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            maxLength: 100,
            maxHeight: 103,
            valueChangeEvent: "input",
            onInput: (e) => {
              this.commentFieldHeightUpdate(e);
            },
            onInitialized: (e) => {
              this.commentFieldHeightUpdate(e);
            },
          },
          setCellValue: async (newData, value) => {
            newData.Comment = value;
            return newData;
          },
        },
        {
          caption: `Amount (${this.dataModel.CurrencyCode})`,
          dataField: "FxAmount",
          cssClass: "edit-cell-numberbox-field",
          format: "##,###,###,###,##0.00",
          editorOptions: {
            format: "##,###,###,###,##0.00",
            onFocusIn: (e) => {
              e.event.target.select();
            },
          },
          width: ColumnWidth.Price2DecimalPoints.width,
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          setCellValue: (newData, value, currentRowData) => {
            newData.FxAmount = value;

            newData.Amount = FxToBaseCurrency(
              value,
              this.dataModel.ExchangeRate,
            );

            this.localDataSource.update(currentRowData.ID, newData);
            this.$nextTick(() => {
              setTimeout(() => {
                if (this.isSundryPaymentScreen()) {
                  this.setFxSundryPaymentSubTotal();
                } else {
                  this.setFxSundryReceiptSubtotal();
                }
              }, 100);
            });

            return newData;
          },
        },
        {
          caption: `Amount (${this.currencyCode})`,
          dataField: "Amount",
          visible: this.dataModel.CurrencyCode != this.currencyCode,
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          width: ColumnWidth.Price2DecimalPoints.width,
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          // setCellValue: (newData, value) => {
          //   newData.Amount = value;
          //   newData.FxAmount = value * this.dataModel.ExchangeRate;
          //   if (this.isSundryPaymentScreen()) {
          //     this.setFxSundryPaymentSubTotal();
          //   } else {
          //     this.setFxSundryReceiptSubtotal();
          //   }
          //   return newData;
          // },
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          buttons: [
            {
              name: "Delete Row",
              icon: "trash",
              onClick: async (e) => {
                const confirmDelete = await this.$confirm(
                  "Are you sure you want to remove this line?",
                  "Delete Entry",
                );
                if (confirmDelete) {
                  this.getGridInstance.deleteRow(e.row.rowIndex);
                }
              },
            },
            {
              hint: "Copy",
              icon: "copy",
              onClick: this.onCopyLine,
            },
          ],
          fixed: true,
          fixedPosition: "right",
          width: 60,
          minWidth: 60,
        },
      ];
    },

    commentFieldHeightUpdate(e) {
      let instance = e.component;
      let count = countLineBreaks(instance.instance().option().value);
      // Adjust the height of the comment field based on the number of line breaks
      // If there are less than 7 line breaks, set the height to count * 16
      // If there are 7 or more line breaks, set the height to 250px
      // This is to ensure that the comment field does not grow too large
      // and remains user-friendly.
      // The height is set to 16px per line break, with a maximum height of 250px
      if (count < 7) {
        if (count > 2) {
          instance.instance().beginUpdate();
          instance.instance().option("height", count * 16);
          instance.instance().endUpdate();
          this.getGridInstance.updateDimensions();
        }
      } else {
        instance.instance().beginUpdate();
        instance.instance().option("height", 250);
        instance.instance().endUpdate();
        this.getGridInstance.updateDimensions();
      }
    },
    getSundryReceiptColumns() {
      return [
        {
          caption: "Account",
          dataField: "GLChartCode",
          width: 200,
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: ProductService.dataSourceConfig("api/GLChart", {
              filter: [
                ["Inactive", "=", "N"],
                "and",
                ["Status", "=", "A"],
                "and",
                ["IsControlAcct", "<>", "Y"],
              ],
              sort: [{ selector: "ComputedStringCode", asc: true }],
              select:
                "Code,ComputedStringCode,Description, Inactive, Status, IsControlAcct,GLAccountSearchText",
            }),
            displayExpr: (e) => {
              if (e) return `${e.Code} - ${e.Description}`;
              else undefined;
            },
            valueExpr: "ComputedStringCode",
            searchExpr: [
              "ComputedStringCode",
              "Description",
              "GLAccountSearchText",
            ],
            searchEnabled: true,
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.Code}" >
                          <span class="auto-complete-primary">
                            ${data.Description}
                          </span>
                          <span class="record-secondary gc-grid-code">
                            ${data.Code}
                          </span>
                        </div>`;
            },
            dropDownOptions: {
              minWidth: 300,
            },
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onValueChanged: (e, cellInfo) => {
              const data = cellInfo.data;
              if (!e || !e.event) return;
              else {
                const instance = e.component;
                const selectedData = instance.option("selectedItem");
                if (selectedData) {
                  // cellInfo.data.GLChartCode = selectedData.ComputedStringCode;
                  cellInfo.data.GLChartDescription = selectedData.Description;

                  this.localDataSource.update(data.ID, {
                    GLChartDescription: selectedData.Description,
                  });

                  this.updateColumnValue(
                    "GLChartCode",
                    selectedData.ComputedStringCode,
                    cellInfo.rowIndex,
                  );
                } else {
                  // cellInfo.data.GLChartCode = undefined;
                  cellInfo.data.GLChartDescription = undefined;
                  this.localDataSource.update(data.ID, {
                    GLChartDescription: undefined,
                  });
                  this.updateColumnValue(
                    "GLChartCode",
                    undefined,
                    cellInfo.rowIndex,
                  );
                }
              }

              this.$nextTick(() => {
                this.focusOnEditableCell(cellInfo.rowIndex, "BranchCode");
              });
            },
            onKeyDown: (e, cellInfo) => {
              if (!e.event) return;
              if (backwardTabbing(e)) {
                if (cellInfo.rowIndex === 0) {
                  e.event.preventDefault();
                  let dataField = "FxSundryReceiptTax";

                  this.$nextTick(() => {
                    this.setFocusOnField(dataField);
                  });
                }
              }
            },
          },
          cssClass: "edit-cell-textbox-field",
          calculateDisplayValue: (e) => {
            if (e.GLChartCode && e.GLChartDescription)
              return e.GLChartCode + " - " + e.GLChartDescription;
            else return "";
          },
          setCellValue: (newData, value, currentRowData) => {
            newData.GLChartCode = value;
            if (!currentRowData.GLChartCode) {
              this.addNextLine(currentRowData, false);
            }
            return newData;
          },
          alignment: "left",
        },
        {
          caption: "Comments",
          dataField: "Comment",
          editorType: "dxTextArea",
          cssClass: "edit-cell-textbox-field comment-text",
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
          allowEditing: true,
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            maxLength: 100,
            maxHeight: 103,
            valueChangeEvent: "input",
            onInput: (e) => {
              this.commentFieldHeightUpdate(e);
            },
            onInitialized: (e) => {
              this.commentFieldHeightUpdate(e);
            },
          },
          setCellValue: async (newData, value) => {
            newData.Comment = value;
            return newData;
          },
        },
        {
          caption: `Amount (${this.dataModel.CurrencyCode})`,
          dataField: "FxAmount",
          cssClass: "edit-cell-numberbox-field",
          format: "##,###,###,###,##0.00",
          editorOptions: {
            format: "##,###,###,###,##0.00",
            onFocusIn: (e) => {
              e.event.target.select();
            },
          },
          width: ColumnWidth.Price2DecimalPoints.width,
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          setCellValue: (newData, value, currentRowData) => {
            newData.FxAmount = value;

            newData.Amount = FxToBaseCurrency(
              value,
              this.dataModel.ExchangeRate,
            );

            this.localDataSource.update(currentRowData.ID, newData);
            this.$nextTick(() => {
              setTimeout(() => {
                if (this.isSundryPaymentScreen()) {
                  this.setFxSundryPaymentSubTotal();
                } else {
                  this.setFxSundryReceiptSubtotal();
                }
              }, 100);
            });

            return newData;
          },
        },
        {
          caption: `Amount (${this.currencyCode})`,
          dataField: "Amount",
          visible: this.dataModel.CurrencyCode != this.currencyCode,
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          width: ColumnWidth.Price2DecimalPoints.width,
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          buttons: [
            {
              name: "Delete Row",
              icon: "trash",
              onClick: async (e) => {
                const confirmDelete = await this.$confirm(
                  "Are you sure you want to remove this line?",
                  "Delete Entry",
                );
                if (confirmDelete) {
                  this.getGridInstance.deleteRow(e.row.rowIndex);
                }
              },
            },
            {
              hint: "Copy",
              icon: "copy",
              onClick: this.onCopyLine,
            },
          ],
          fixed: true,
          fixedPosition: "right",
          width: 60,
          minWidth: 60,
        },
      ];
    },

    onEditorPreparing(e) {
      // if (e.dataField && e.dataField == "ProcessCode") {
      //   e.editorName = "dxSelectBox";
      // }
      if (e.dataField && e.dataField == "Comment") {
        e.editorName = "dxTextArea";
      }

      if (e.parentType !== "searchPanel") {
        const { dataField, editorOptions, row } = e;
        // Only wrap handlers if not in the search panel
        if (!editorOptions) return;

        const wrapHandler = (handlerName) => {
          const original = editorOptions[handlerName];
          if (typeof original === "function") {
            editorOptions[handlerName] = (event) => {
              original(event, {
                column: { dataField },
                data: row.data,
                rowIndex: row.rowIndex,
              });
            };
          }
        };

        // Wrap each handler if it exists
        [
          "onValueChanged",
          "onItemClick",
          "onKeyDown",
          "onOpened",
          "onFocusIn",
        ].forEach(wrapHandler);
      }
    },

    async addNextLine(rowInfo, refresh = false) {
      const items = await this.localDataSource.load();
      const rowIndex = items.findIndex((x) => x.ID === rowInfo.ID);
      if (rowIndex + 1 === items.length) {
        this.localDataSource.insert({
          ...baseLine,
          Comment: this.dataModel.DefaultComment
            ? this.dataModel.Narration
            : "",
        });
      }

      if (refresh) {
        this.$nextTick(() => {
          if (this.getGridInstance) {
            this.getGridInstance.refresh();
          }
        });
      }
    },
    /**
     * Fill only empty-Comment lines with the current Narration text.
     * Mirrors journal-v2.vue's setAllEmptyCommentsItem().
     */
    setAllEmptyCommentsItem() {
      const emptyComments = this.localDataSource._array.filter(
        (item) =>
          item.Comment === "" ||
          item.Comment === null ||
          typeof item.Comment === "undefined",
      );
      emptyComments.forEach((item) => {
        item.Comment = this.dataModel.Narration;
      });
      if (this.getGridInstance) {
        this.getGridInstance.refresh();
      }
    },

    async onSaved(e) {
      if (e.changes && e.changes.length > 0) {
        const change = e.changes[0];
        if (change.insertAfterKey !== undefined) {
          const element = change.data;
          let index = -1;
          const items = await this.localDataSource.load();
          index = items.findIndex((x) => x.ID === change.insertAfterKey);
          items.splice(items.length - 1, 1);
          items.splice(index + 1, 0, element);

          this.localDataSource._array = items;

          if (index !== -1)
            setTimeout(() => {
              this.focusOnEditableCell(index + 1, "GLChartCode");
            }, 100);
        }
      }
    },

    async onRowRemoved(e) {
      const dataField = "GLChartCode";
      const items = await this.localDataSource.load();
      if (items.length === 0) {
        this.localDataSource.insert(baseLine);
        e.component.refresh();
        await this.$nextTick();

        setTimeout(() => {
          this.focusOnEditableCell(0, dataField);
        }, 100);
      } else {
        if (e.data && !e.data.GLChartCode) {
          e.component.refresh();
          await this.$nextTick();

          setTimeout(() => {
            this.focusOnEditableCell(items.length, dataField);
          }, 100);
        }
      }

      setTimeout(() => {
        if (this.isSundryPaymentScreen()) {
          this.setFxSundryPaymentSubTotal();
        } else {
          this.setFxSundryReceiptSubtotal();
        }
      }, 110);
    },

    focusOnEditableCell(rowIndex, col) {
      const column = col ? col : "GLChartCode";
      const dataGrid = this.getGridInstance;
      if (!dataGrid) return;
      const cellElement = dataGrid.getCellElement(rowIndex, column);
      dataGrid.focus(cellElement);
      setTimeout(() => {
        dataGrid.editCell(rowIndex, column);
      }, 10);
    },

    async onCopyLine(e) {
      if (!e || !e.row || !e.row.data) return;
      const data = e.row.data;
      const rowIndex = e.row.rowIndex;

      if (!data.GLChartCode) {
        await this.$alert("Account field is required", "Validation Error");
        this.focusOnEditableCell(rowIndex, "GLChartCode");
      } else if (this.isSundryPaymentScreen() && !data.BranchCode) {
        await this.$alert("Branch field is required", "Validation Error");
        this.focusOnEditableCell(rowIndex, "BranchCode");
      } else if (this.isSundryPaymentScreen() && !data.DivisionCode) {
        await this.$alert("Division field is required", "Validation Error");
        this.focusOnEditableCell(rowIndex, "DivisionCode");
      } else if (!data.Amount || data.Amount === 0) {
        await this.$alert("Amount field is required", "Validation Error");
        this.focusOnEditableCell(rowIndex, "FxAmount");
      } else {
        const newData = { ...data, ID: undefined };

        this.changes = [
          {
            type: "insert",
            data: newData,
            insertAfterKey: e.row.key,
          },
        ];

        const dataGrid = this.getGridInstance;
        dataGrid.clearSelection();
        dataGrid.option("focusedRowIndex", -1);

        this.$nextTick(() => {
          dataGrid.saveEditData();
          dataGrid.refresh(true);

          setTimeout(() => {
            if (this.isSundryPaymentScreen()) {
              this.setFxSundryPaymentSubTotal();
            } else {
              this.setFxSundryReceiptSubtotal();
            }
          }, 1);
        });
      }
    },

    async initialized() {
      await CompanyService.getCompany({
        select: "CurrencyCode,Code,Name",
      }).then(({ data }) => {
        this.currencyCode = data.value[0].CurrencyCode;
        this.dataModel.CurrencyCode = data.value[0].CurrencyCode;
      });
      this.loadSundryReceiptBranch();
      this.loadSundryReceiptDivision();
      this.loadDate();
      this.loadDefaultScreen();
      if (this.isBankAccountSelectionRequired) {
        await this.loadBankAccountOptions();
      }
      await this.loadPartnerListOptions();
      await JournalDetailServices.getActiveAccountPeriod().then(({ data }) => {
        this.minDate = data.value[0].DateStart;
        this.maxDate = data.value[0].DateEnd;
      });
      await this.$store.dispatch("screenFactors/getFactors", [65, 66]);
      baseLine.BranchCode = this.defaultBranchCode =
        getFactorByCode(65).Factorc;
      baseLine.DivisionCode = this.defaultDivisionCode =
        getFactorByCode(66).Factorc;
      if (this.localDataSource._array.length === 0) {
        this.localDataSource.insert(baseLine);
      }
      await this.setBranchDataSourceItems();
      await this.setDivisionDataSourceItems();
      // await this.setGLChartDataSourceItems();
    },
    loadDefaultScreen() {
      this.selectedScreen = this.popUpScreenOptions().find(
        (element) => element.isDefault === true,
      ).value;
    },
    async loadBankAccountOptions() {
      if (this.bankAccountDataSource.length === 0) {
        await BankAccountsServices.getCustomData({
          url: "BankRecord",
          filter: "Inactive eq 'N'",
          orderby: "AccountName asc",
        }).then(({ data }) => {
          this.bankAccountDataSource = data.value;
        });
      }
    },
    async loadPartnerListOptions() {
      if (this.supplierListOptions.length === 0) {
        await SupplierService.getAllSupplier().then(({ data }) => {
          this.supplierListOptions = data.value;
        });
      }
      if (this.customerListOptions.length === 0) {
        await CustomerService.getAllCustomer().then(({ data }) => {
          this.customerListOptions = data.value;
        });
      }
    },
    onBankAccountChanged(e) {
      this.selectedBankAccountCode = e.value;
      this.selectedBankAccount = this.bankAccountDataSource.find(
        (account) => account.Code === e.value,
      );

      if (this.selectedBankAccount) {
        this.selectedBankCurrency = this.selectedBankAccount.CurrencyCode;

        this.$nextTick(() => {
          this.$refs["sundry-transaction-data-form"].formRepaint();
        });
      }
    },
    clearDataModel() {
      this.dataModel = {
        SundryPaymentDate: new Date(),
        SundryPaymentPayeeName: undefined,
        SundryPaymentAmount: undefined,
        SundryPaymentTax: 0.0,
        SundryPaymentBASReportable: true,
        SundryPaymentSupplierCode: undefined,
        FxSundryPaymentSubTotal: 0,
        SundryPaymentTotal: 0,
        FxSundryPaymentTotal: 0,

        FxSundryPaymentAmount: 0,
        FxSundryPaymentTax: 0.0,

        SundryReceiptDate: new Date(),
        SundryReceiptPayer: undefined,
        SundryReceiptCustomerCode: undefined,
        SundryReceiptPaymentMethod: undefined,
        SundryReceiptBranch: undefined,
        SundryReceiptDivision: undefined,
        SundryReceiptAmount: undefined,
        FxSundryReceiptAmount: 0.0,
        SundryReceiptTax: 0.0,
        FxSundryReceiptTax: 0.0,
        SundryReceiptBASReportable: true,
        SundryReceiptSubTotal: 0,
        FxSundryReceiptSubTotal: 0,
        SundryReceiptTotal: 0,
        FxSundryReceiptTotal: 0,
        CurrencyCode: undefined,
        ExchangeRate: 1,
        PaymentMethods: [],
        Narration: undefined,
        DefaultComment: false,
      };
    },
    clearScreenData(e) {
      this.localDataSource.clear();
      this.selectedScreen = e.value;
      this.dataModel = {
        SundryPaymentDate: new Date(),
        SundryPaymentPayeeName: undefined,
        SundryPaymentAmount: undefined,
        SundryPaymentTax: 0.0,
        SundryPaymentBASReportable: true,
        SundryPaymentSupplierCode: undefined,
        FxSundryPaymentSubTotal: 0,
        SundryPaymentTotal: 0,
        FxSundryPaymentTotal: 0,

        FxSundryPaymentAmount: 0,
        FxSundryPaymentTax: 0.0,

        SundryReceiptDate: new Date(),
        SundryReceiptPayer: undefined,
        SundryReceiptCustomerCode: undefined,
        SundryReceiptPaymentMethod: undefined,
        SundryReceiptBranch: undefined,
        SundryReceiptDivision: undefined,
        SundryReceiptAmount: undefined,
        FxSundryReceiptAmount: 0.0,
        SundryReceiptTax: 0.0,
        FxSundryReceiptTax: 0.0,
        SundryReceiptBASReportable: true,
        SundryReceiptSubTotal: 0,
        FxSundryReceiptSubTotal: 0,
        SundryReceiptTotal: 0,
        FxSundryReceiptTotal: 0,
        CurrencyCode: undefined,
        ExchangeRate: 1,
        PaymentMethods: [],
        Narration: undefined,
        DefaultComment: false,
      };
      if (e.value == "new-sundry-payment") {
        this.localDataSource.insert(baseLine);
      } else {
        this.localDataSource.insert(baseLine);
      }
      if (e.value == "new-sundry-receipt") {
        if (this.dataModel.PaymentMethods.length == 0)
          BankAccountTransactionServices.getPaymentMethods().then(
            ({ data }) => {
              var PaymentMethods = data.value;
              this.dataModel.PaymentMethods = PaymentMethods;
              this.dataModel.SundryReceiptPaymentMethod = data.value.filter(
                (val) => val.isDefault === 1,
              )[0].PayType;
            },
          );
        else {
          this.dataModel.SundryReceiptPaymentMethod =
            this.dataModel.PaymentMethods.filter(
              (val) => val.isDefault === 1,
            )[0].PayType;
        }
      }

      CompanyService.getCompany().then(({ data }) => {
        this.currencyCode = data.value[0].CurrencyCode;
        this.dataModel.CurrencyCode = data.value[0].CurrencyCode;
      });
      this.loadSundryReceiptBranch();
      this.loadSundryReceiptDivision();
      this.loadDate();
    },
    clearSundryPaymentScreenData() {
      this.localDataSource.clear();
      this.dataModel = {
        SundryPaymentDate: new Date(),
        SundryPaymentPayeeName: undefined,
        SundryPaymentAmount: undefined,
        SundryPaymentTax: 0.0,
        SundryPaymentBASReportable: true,
        SundryPaymentSupplierCode: undefined,
        FxSundryPaymentSubTotal: 0,
        SundryPaymentTotal: 0,
        FxSundryPaymentTotal: 0,

        FxSundryPaymentAmount: 0,
        FxSundryPaymentTax: 0.0,

        SundryReceiptDate: new Date(),
        SundryReceiptPayer: undefined,
        SundryReceiptCustomerCode: undefined,
        SundryReceiptPaymentMethod: undefined,
        SundryReceiptBranch: undefined,
        SundryReceiptDivision: undefined,
        SundryReceiptAmount: undefined,
        FxSundryReceiptAmount: 0.0,
        SundryReceiptTax: 0.0,
        FxSundryReceiptTax: 0.0,
        SundryReceiptBASReportable: true,
        SundryReceiptSubTotal: 0,
        FxSundryReceiptSubTotal: 0,
        SundryReceiptTotal: 0,
        FxSundryReceiptTotal: 0,
        CurrencyCode: undefined,
        ExchangeRate: 1,
        PaymentMethods: [],
        Narration: undefined,
        DefaultComment: false,
      };
      this.localDataSource.insert(baseLine);
    },
    clearSundryReceiptScreenData() {
      this.localDataSource.clear();
      this.dataModel = {
        SundryPaymentDate: new Date(),
        SundryPaymentPayeeName: undefined,
        SundryPaymentAmount: undefined,
        SundryPaymentTax: 0.0,
        SundryPaymentBASReportable: true,
        SundryPaymentSupplierCode: undefined,
        FxSundryPaymentSubTotal: 0,
        SundryPaymentTotal: 0,
        FxSundryPaymentTotal: 0,

        FxSundryPaymentAmount: 0,
        FxSundryPaymentTax: 0.0,

        SundryReceiptDate: new Date(),
        SundryReceiptPayer: undefined,
        SundryReceiptCustomerCode: undefined,
        SundryReceiptPaymentMethod: undefined,
        SundryReceiptBranch: undefined,
        SundryReceiptDivision: undefined,
        SundryReceiptAmount: undefined,
        FxSundryReceiptAmount: 0.0,
        SundryReceiptTax: 0.0,
        FxSundryReceiptTax: 0.0,
        SundryReceiptBASReportable: true,
        SundryReceiptSubTotal: 0,
        FxSundryReceiptSubTotal: 0,
        SundryReceiptTotal: 0,
        FxSundryReceiptTotal: 0,
        CurrencyCode: undefined,
        ExchangeRate: 1,
        PaymentMethods: [],
        Narration: undefined,
        DefaultComment: false,
      };
      this.localDataSource.insert(baseLine);
    },
    handleSaveVisibility() {
      if (
        this.isBankAccountSelectionRequired &&
        !this.resolvedBankAccountCode
      ) {
        return true;
      }
      if (this.isSundryPaymentScreen()) {
        return this.disableSundryPaymentSave();
      } else {
        return this.disableSundryReceiptSave();
      }
    },
    disableSundryPaymentSave() {
      return (
        this.dataModel.SundryPaymentAmount !=
          this.dataModel.SundryPaymentTotal ||
        this.dataModel.SundryPaymentTotal === 0
      );
    },
    disableSundryReceiptSave() {
      return (
        this.dataModel.SundryReceiptAmount !=
          this.dataModel.SundryReceiptTotal ||
        this.dataModel.SundryReceiptTotal === 0
      );
    },
    handleSave(validLines) {
      this.isSundryPaymentScreen()
        ? this.onGcSundryPaymentSave(validLines)
        : this.onGcSundryReceiptSave(validLines);
    },
    isSundryPaymentScreen() {
      return this.selectedScreen === "new-sundry-payment";
    },
    onSundryPaymentTaxChanged() {
      this.dataModel.FxSundryPaymentTotal =
        this.dataModel.FxSundryPaymentSubTotal +
        this.dataModel.FxSundryPaymentTax;

      this.dataModel.SundryPaymentTotal = FxToBaseCurrency(
        this.dataModel.FxSundryPaymentTotal,
        this.dataModel.ExchangeRate,
      );
    },
    onSundryReceiptTaxChanged() {
      this.dataModel.FxSundryReceiptTotal =
        this.dataModel.FxSundryReceiptSubTotal +
        this.dataModel.FxSundryReceiptTax;
      this.dataModel.SundryReceiptTotal = FxToBaseCurrency(
        this.dataModel.FxSundryReceiptTotal,
        this.dataModel.ExchangeRate,
      );
    },
    setSundryReceiptTotal() {
      this.dataModel.FxSundryReceiptTotal =
        this.dataModel.FxSundryReceiptSubTotal +
        this.dataModel.FxSundryReceiptTax;
      this.dataModel.SundryReceiptTotal = FxToBaseCurrency(
        this.dataModel.FxSundryReceiptTotal,
        this.dataModel.ExchangeRate,
      );
    },
    setSundryPaymentTotal() {
      this.dataModel.FxSundryPaymentTotal =
        this.dataModel.FxSundryPaymentSubTotal +
        this.dataModel.FxSundryPaymentTax;

      this.dataModel.SundryPaymentTotal = FxToBaseCurrency(
        this.dataModel.FxSundryPaymentTotal,
        this.dataModel.ExchangeRate,
      );
    },
    async setFxSundryPaymentSubTotal() {
      const items = await this.localDataSource.load();
      let total = 0;
      items.forEach((localItem) => {
        total = total + localItem.FxAmount;
      });

      this.dataModel.FxSundryPaymentSubTotal = total;
      this.setSundryPaymentTotal();
    },
    async setFxSundryReceiptSubtotal() {
      let total = 0;
      const items = await this.localDataSource.load();
      items.forEach((localItem) => {
        total = total + localItem.FxAmount;
      });
      this.dataModel.FxSundryReceiptSubTotal = total;
      this.setSundryReceiptTotal();
    },
    async onGcSundryReceiptSave(validLines) {
      var payload = {
        DateIn: this.dataModel.SundryReceiptDate.toSaveDate(),
        SundryReceiptDetails: [],
        Bsbno: this.resolvedBSBNO,
        BankAccountNo: this.resolvedAccountNo,
        DivisionCode: this.dataModel.SundryReceiptDivision,
        BranchCode: this.dataModel.SundryReceiptBranch,
        PayeeName: this.dataModel.SundryReceiptPayer,
        CustomerCode: this.dataModel.SundryReceiptCustomerCode,
        IsGstReportable: this.dataModel.SundryReceiptBASReportable,
        BankAccountCode: parseInt(this.resolvedBankAccountCode),
        ExTaxAmount: FxToBaseCurrency(
          this.dataModel.FxSundryReceiptSubTotal,
          this.dataModel.ExchangeRate,
        ),
        TaxAmount: this.dataModel.SundryReceiptTax.roundNumber(2),
        IncTaxAmount: this.dataModel.SundryReceiptTotal.roundNumber(2),
        PaymentMethod: this.dataModel.SundryReceiptPaymentMethod,

        FXTaxAmount: this.dataModel.FxSundryReceiptTax,
        FXExTaxAmount: this.dataModel.FxSundryReceiptSubTotal,
        FXIncTaxAmount: this.dataModel.FxSundryReceiptTotal.roundNumber(2),
        ExchangeRate: this.dataModel.ExchangeRate,
        CurrencyCode: this.dataModel.CurrencyCode,
        Reference: this.dataModel.Reference,
        Narration: this.dataModel.Narration,
      };
      validLines.forEach((element) => {
        payload.SundryReceiptDetails.push({
          AccountCode: element.GLChartCode,
          Amount: element.Amount.roundNumber(2),
          FXAmount: element.FxAmount.roundNumber(2),
          Comment: element.Comment ? element.Comment : "",
        });
      });
      this.validationSummary = [];
      this.validateSundryReceiptGrid();
      this.validateSundryReceipt();
      if (this.validationSummary.length > 0) {
        this.showValidationSummary(this.validationSummary);
      } else {
        this.setLoading(true);
        await BankAccountTransactionServices.saveSundryReceipt(payload)
          .then(async (res) => {
            this.$notify("Sundry Receipt Successfully Saved", "success");
            if (res) {
              this.dataModel = {
                SundryPaymentDate: new Date(),
                SundryPaymentPayeeName: undefined,
                SundryPaymentAmount: undefined,
                SundryPaymentTax: 0.0,
                SundryPaymentBASReportable: true,
                SundryPaymentSupplierCode: undefined,
                FxSundryPaymentSubTotal: 0,
                SundryPaymentTotal: 0,
                FxSundryPaymentTotal: 0,

                FxSundryPaymentAmount: 0,
                FxSundryPaymentTax: 0.0,

                SundryReceiptDate: new Date(),
                SundryReceiptPayer: undefined,
                SundryReceiptCustomerCode: undefined,
                SundryReceiptPaymentMethod: undefined,
                SundryReceiptBranch: undefined,
                SundryReceiptDivision: undefined,
                SundryReceiptAmount: undefined,
                FxSundryReceiptAmount: 0.0,
                SundryReceiptTax: 0.0,
                FxSundryReceiptTax: 0.0,
                SundryReceiptBASReportable: true,
                SundryReceiptSubTotal: 0,
                FxSundryReceiptSubTotal: 0,
                SundryReceiptTotal: 0,
                FxSundryReceiptTotal: 0,
                CurrencyCode: undefined,
                ExchangeRate: 1,
                PaymentMethods: [],
                Narration: undefined,
                DefaultComment: false,
              };
              const items = await this.localDataSource.load();
              items.forEach(() => items.pop());
              this.localDataSource.insert(baseLine);

              this.gcSundryTransactionPopupConfig.init();
              if (this.gcSundryTransactionPopupConfig.onSaveCallBack) {
                this.gcSundryTransactionPopupConfig.onSaveCallBack();
              }
              this.setLoading(false);
              this.gcSundryTransactionPopupConfig.gcPopupCallBack();
              this.isPopupHiddenBySave = true;
              await this.initialized();
            }
          })
          .catch((err) => {
            if (err) {
              this.setLoading(false);
              this.$store.dispatch("ui/setServerError", {
                error: err,
                title: "Failed",
              });
            }
          });
      }
    },
    async onGcSundryPaymentSave(validLines) {
      const items = await this.localDataSource.load();

      var payload = {
        SupplierCode: this.dataModel.SundryPaymentSupplierCode,
        PayeeName: this.dataModel.SundryPaymentPayeeName,
        DateIn: this.dataModel.SundryPaymentDate.toSaveDate(),
        BankAccountCode: parseInt(this.resolvedBankAccountCode),
        GSTAmount: this.dataModel.SundryPaymentTax,
        IncTaxAmount: this.dataModel.SundryPaymentTotal.roundNumber(2),
        ExTaxAmount: FxToBaseCurrency(
          this.dataModel.FxSundryPaymentSubTotal,
          this.dataModel.ExchangeRate,
        ),
        IsGstReportable: this.dataModel.SundryPaymentBASReportable,

        FXTaxAmount: this.dataModel.FxSundryPaymentTax,
        FXExTaxAmount: this.dataModel.FxSundryPaymentSubTotal,
        FXIncTaxAmount: this.dataModel.FxSundryPaymentTotal.roundNumber(2),
        ExchangeRate: this.dataModel.ExchangeRate,
        CurrencyCode: this.dataModel.CurrencyCode,
        Reference: this.dataModel.Reference,
        Narration: this.dataModel.Narration,
      };
      payload.SundryPaymentDetails = validLines.map((element) => {
        var data = {
          Amount: element.Amount.roundNumber(2),
          FXAmount: element.FxAmount.roundNumber(2),
          BranchCode: element.BranchCode,
          Comment: element.Comment ? element.Comment : "",
          DivisionCode: element.DivisionCode,
          AccountCode: element.GLChartCode,
          ItemCode: "",
        };
        return data;
      });
      this.validationSummary = [];
      this.validateSundryPaymentGrid();
      this.validateSundryPayment();
      if (this.validationSummary.length > 0) {
        this.showValidationSummary(this.validationSummary);
      } else {
        this.setLoading(true);
        await BankAccountTransactionServices.saveSundryPayment(payload)
          .then(async (res) => {
            this.$notify("Sundry Payment Successfully Saved", "success");
            if (res) {
              items.forEach(() => items.pop());
              this.gcSundryTransactionPopupConfig.init();
              if (this.gcSundryTransactionPopupConfig.onSaveCallBack) {
                this.gcSundryTransactionPopupConfig.onSaveCallBack();
              }
              this.clearDataModel();
              this.setLoading(false);
              this.gcSundryTransactionPopupConfig.gcPopupCallBack();
              this.isPopupHiddenBySave = true;
              await this.initialized();
            }
          })
          .catch((err) => {
            if (err) {
              this.setLoading(false);

              this.$store.dispatch("ui/setServerError", {
                error: err,
                title: "Failed",
              });
            }
          });
      }
    },
    loadDate() {
      this.dataModel.SundryPaymentDate = this.dataModel.SundryReceiptDate =
        new Date();
    },
    loadSundryReceiptDivision() {
      if (this.getUserDefaulDivision())
        this.dataModel.SundryReceiptDivision = this.getUserDefaulDivision();
      else
        this.dataModel.SundryReceiptDivision = this.getSystemDefaultDivision();
    },
    loadSundryReceiptBranch() {
      if (this.getUserDefaultBranch()) {
        this.dataModel.SundryReceiptBranch = this.getUserDefaultBranch();
      } else {
        this.dataModel.SundryReceiptBranch = this.getSystemDefaultBranch();
      }
    },
    getUserDefaulDivision() {
      return getDefaultUserSettings().DivisionCode;
    },
    async getSystemDefaultDivision() {
      var systemDefaultDivision = await DivisionService.getDefault();
      return systemDefaultDivision.data.value[0].Code;
    },

    getUserDefaultBranch() {
      return getDefaultUserSettings().BranchCode;
    },
    async getSystemDefaultBranch() {
      var systemDefaultBranch = await BranchService.getDefault();
      return systemDefaultBranch.data.value[0].Code;
    },

    populateSundryReceiptHeader() {
      return {
        value: "new-sundry-receipt",
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    screenField: "Date",
                    dataField: "SundryReceiptDate",
                    required: true,
                    label: {
                      text: "Date",
                    },
                    editorOptions: {
                      // tabIndex: 1,
                      min: this.minDate,
                      max: this.maxDate,
                      allowUpdate: true,
                      search: true,
                      onFocusIn: (e) => {
                        e.event.target.select();
                      },
                      dateOutOfRangeMessage: `Date must be between ${new Date(
                        this.minDate,
                      ).toShortDateString()} and ${new Date(
                        this.maxDate,
                      ).toShortDateString()}.`,
                    },
                    validationRules: [
                      {
                        type: "custom",
                        validationCallback: ({ value, rule }) => {
                          rule.message = `Date must be between ${new Date(
                            this.minDate,
                          ).toShortDateString()} and ${new Date(
                            this.maxDate,
                          ).toShortDateString()}.`;

                          const toDateOnly = (d) => {
                            const dt = new Date(d);
                            dt.setHours(0, 0, 0, 0);
                            return dt;
                          };

                          const selectedDate = toDateOnly(value);
                          const minDate = toDateOnly(this.minDate);
                          const maxDate = toDateOnly(this.maxDate);

                          return (
                            selectedDate >= minDate && selectedDate <= maxDate
                          );
                        },
                        reevaluate: true,
                      },
                    ],
                  },

                  {
                    screenField: "Branch",
                    dataField: "SundryReceiptBranch",
                    cssClass: "toolbar-customer-label",
                    editorOptions: {
                      allowUpdate: true,
                      dropDownOptions: {
                        minWidth: 220,
                      },
                      placeholder: "",
                      // tabIndex: 2,
                      showClearButton: true,
                    },
                    label: {
                      text: "Branch",
                    },
                    dataSourceConfig: {
                      endpoint: "api/Branch",
                      sort: {
                        selector: "Code",
                        asc: true,
                      },
                      filter: [["Inactive", "=", "N"]],
                      select: "Code,Description,RecordId",
                    },
                    required: true,
                    displayExpr: (item) => {
                      if (item) {
                        return `${item.Code} - ${item.Description}`;
                      }
                      return "";
                    },
                    searchExpr: ["Code", "Description"],
                  },
                  {
                    screenField: "Division",
                    dataField: "SundryReceiptDivision",
                    cssClass: "toolbar-customer-label",
                    editorOptions: {
                      // tabIndex: 3,
                      allowUpdate: true,
                      dropDownOptions: {
                        minWidth: 220,
                      },
                      placeholder: "",
                      showClearButton: true,
                    },
                    dataSourceConfig: {
                      endpoint: "api/Division",
                      sort: {
                        selector: "Code",
                        asc: true,
                      },
                      filter: [["Inactive", "=", "N"]],
                      select: "Code,Description,RecordId",
                    },
                    label: {
                      text: "Division",
                    },
                    required: true,
                    displayExpr: (item) => {
                      if (item) {
                        return `${item.Code} - ${item.Description}`;
                      }
                      return "";
                    },
                    searchExpr: ["Code", "Description"],
                  },
                  {
                    screenField: "Customer",
                    dataField: "SundryReceiptCustomerCode",
                    cssClass: "toolbar-customer-label",
                    editorOptions: {
                      allowUpdate: true,
                      dropDownOptions: {
                        minWidth: 220,
                      },
                      placeholder: "Customer Name",
                      showClearButton: true,
                      onSelectionChanged:
                        this.onCustomerCodeValueChanged.bind(this),
                    },
                    label: {
                      text: "Customer",
                    },
                    required: true,
                    filter:
                      this.selectedBankCurrency &&
                      this.selectedBankCurrency != this.currencyCode
                        ? [
                            [
                              "CurrencyCode",
                              "=",
                              `${this.selectedBankCurrency}`,
                            ],
                          ]
                        : this.gcSundryTransactionPopupConfig.dataModel
                            .FXCurrency != undefined &&
                          this.gcSundryTransactionPopupConfig.dataModel
                            .FXCurrency != this.currencyCode
                        ? [
                            [
                              "CurrencyCode",
                              "=",
                              `${this.gcSundryTransactionPopupConfig.dataModel.FXCurrency}`,
                            ],
                          ]
                        : undefined,
                    displayExpr: (item) => {
                      if (item) {
                        return `${item.Code} - ${item.Name}`;
                      }
                      return "";
                    },
                    searchExpr: ["Code", "Name"],
                  },
                  {
                    screenField: "PayeeName",
                    dataField: "SundryReceiptPayer",
                    label: {
                      text: "Payer",
                    },
                    required: true,
                    editorOptions: {
                      // tabIndex: 5,
                      allowUpdate: true,
                      onFocusIn: (e) => {
                        this.isEditingPayerField = true;
                        e.event.target.select();
                      },
                      onFocusOut: () => {
                        this.isEditingPayerField = false;
                      },
                      onKeyDown: (e) => {
                        if (forwardTabbing(e)) {
                          setTimeout(() => {
                            this.$nextTick(() => {
                              this.setFocusOnField(
                                "SundryReceiptPaymentMethod",
                              );
                            });
                          }, 200);
                        }
                      },
                    },
                    defaultValue: this.dataModel.SundryReceiptPayer,
                  },
                  {
                    screenField: "PaymentMethod",
                    dataField: "SundryReceiptPaymentMethod",
                    cssClass: "toolbar-customer-label",
                    dataSourceConfig: {
                      data: this.dataModel.PaymentMethods,
                    },
                    editorOptions: {
                      // tabIndex: 6,
                      allowUpdate: true,
                      dropDownOptions: {
                        minWidth: 220,
                      },
                      placeholder: "Payment Method",
                      showClearButton: true,
                      onFocusIn: (e) => {
                        e.event.target.select();
                      },
                    },
                    label: {
                      text: "Payment Method",
                    },
                    required: true,
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "Reference",
                    label: {
                      text: "Reference",
                    },
                    editorOptions: {
                      // tabIndex: 7,
                      maxLength: 100,
                      allowUpdate: true,
                    },
                  },
                  {
                    dataField: "Narration",
                    label: {
                      text: "Narration",
                    },
                    editorType: "dxTextArea",
                    editorOptions: {
                      allowUpdate: true,
                      maxLength: 100,
                      height: 86,
                      onFocusOut: () => {
                        if (this.dataModel.DefaultComment) {
                          this.setAllEmptyCommentsItem();
                        }
                      },
                    },
                  },
                  {
                    dataField: "DefaultComment",
                    label: {
                      text: "Default Comment",
                    },
                    editorType: "dxCheckBox",
                    editorOptions: {
                      allowUpdate: true,
                      onValueChanged: (e) => {
                        if (e.value) {
                          this.setAllEmptyCommentsItem();
                        }
                      },
                    },
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "SundryReceiptBASReportable",
                    label: {
                      text: "BAS Reportable",
                    },
                    cssClass: "myCss",
                    editorType: "dxCheckBox",
                    editorOptions: {
                      // tabIndex: 13,
                      allowUpdate: true,
                    },
                  },
                  {
                    itemType: "group",
                    caption: "",
                    colCount: 2,
                    cssClass: "sundry-receipt-amount-group",
                    items: [
                      {
                        screenField: "Currency",
                        displayExpr: "CurrencyCode",
                      },

                      {
                        screenField: "ExchangeRate",
                        cssClass: "remove-padding-bottom",
                        editorOptions: {
                          tabIndex:
                            this.dataModel.CurrencyCode != this.currencyCode
                              ? undefined
                              : -1,
                          allowUpdate:
                            this.dataModel.CurrencyCode != this.currencyCode,
                          onValueChanged: async (e) => {
                            const items = await this.localDataSource.load();
                            this.dataModel.ExchangeRate = e.value;
                            items.forEach((element) => {
                              element.Amount = FxToBaseCurrency(
                                element.FxAmount,
                                e.value,
                              );
                            });

                            this.dataModel.SundryReceiptAmount =
                              this.dataModel.FxSundryReceiptAmount /
                              this.dataModel.ExchangeRate;
                            this.dataModel.SundryReceiptTax =
                              this.dataModel.FxSundryReceiptTax /
                              this.dataModel.ExchangeRate;
                            this.onSundryReceiptTaxChanged();
                          },
                        },
                      },
                      {
                        screenField: "FXAmount",
                        dataField: "FxSundryReceiptAmount",
                        format: "Decimal-16-2",
                        required: true,
                        label: {
                          text: `Amount (${this.dataModel.CurrencyCode})`,
                        },
                        editorOptions: {
                          // tabIndex: 9,
                          allowUpdate: true,
                          onValueChanged: (e) => {
                            this.dataModel.FxSundryReceiptAmount = e.value;
                            this.dataModel.SundryReceiptAmount =
                              FxToBaseCurrency(
                                e.value,
                                this.dataModel.ExchangeRate,
                              );
                          },
                        },
                      },

                      {
                        screenField: "TaxTotal",
                        dataField: "FxSundryReceiptTax",
                        format: "Decimal-16-2",
                        cssClass: "remove-padding-bottom",
                        required: false,
                        label: {
                          text: `Tax (${this.dataModel.CurrencyCode})`,
                        },
                        editorOptions: {
                          // tabIndex: 11,
                          allowUpdate: true,
                          onValueChanged: ({ value }) => {
                            this.dataModel.FxSundryReceiptTax = value;
                            this.dataModel.SundryReceiptTax = FxToBaseCurrency(
                              value,
                              this.dataModel.ExchangeRate,
                            );
                            this.onSundryReceiptTaxChanged(value);
                          },
                          onKeyDown: (e) => {
                            this.tabIntoGrid(e);
                          },
                        },
                      },
                      {
                        screenField: "FXAmount",
                        dataField: "SundryReceiptAmount",
                        format: "Decimal-16-2",
                        required: true,
                        visible:
                          this.dataModel.CurrencyCode != this.currencyCode,
                        label: {
                          text: `Amount (${
                            getDefaultUserSettings().CurrencyCode
                          })`,
                        },
                        editorOptions: {
                          tabIndex:
                            this.dataModel.CurrencyCode != this.currencyCode
                              ? undefined
                              : -1,
                          // allowUpdate: true,
                          // onValueChanged: (e) => {
                          //   this.dataModel.SundryReceiptAmount = e.value;
                          //   this.dataModel.FxSundryReceiptAmount =
                          //     e.value * this.dataModel.ExchangeRate;
                          // },
                        },
                      },

                      {
                        screenField: "TaxTotal",
                        dataField: "SundryReceiptTax",
                        format: "Decimal-16-2",
                        required: false,
                        cssClass: "remove-padding-bottom",
                        visible:
                          this.dataModel.CurrencyCode != this.currencyCode,
                        label: {
                          text: `Tax (${
                            getDefaultUserSettings().CurrencyCode
                          })`,
                        },
                        editorOptions: {
                          tabIndex:
                            this.dataModel.CurrencyCode != this.currencyCode
                              ? undefined
                              : -1,
                          // allowUpdate: true,
                          // onValueChanged: ({ value }) => {
                          //   this.dataModel.SundryReceiptTax = value;
                          //   this.dataModel.FxSundryReceiptTax =
                          //     value * this.dataModel.ExchangeRate;
                          //   this.onSundryReceiptTaxChanged();
                          // },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    populateSundryPaymentHeader() {
      return {
        value: "new-sundry-payment",
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    screenField: "Date",
                    dataField: "SundryPaymentDate",
                    required: true,
                    label: {
                      text: "Date",
                    },
                    editorOptions: {
                      min: this.minDate,
                      max: this.maxDate,
                      allowUpdate: true,
                      search: true,
                      onFocusIn: (e) => {
                        e.event.target.select();
                      },
                      dateOutOfRangeMessage: `Date must be between ${new Date(
                        this.minDate,
                      ).toShortDateString()} and ${new Date(
                        this.maxDate,
                      ).toShortDateString()}.`,
                    },
                    validationRules: [
                      {
                        type: "custom",
                        validationCallback: ({ value, rule }) => {
                          rule.message = `Date must be between ${new Date(
                            this.minDate,
                          ).toShortDateString()} and ${new Date(
                            this.maxDate,
                          ).toShortDateString()}.`;

                          const toDateOnly = (d) => {
                            const dt = new Date(d);
                            dt.setHours(0, 0, 0, 0);
                            return dt;
                          };

                          const selectedDate = toDateOnly(value);
                          const minDate = toDateOnly(this.minDate);
                          const maxDate = toDateOnly(this.maxDate);

                          return (
                            selectedDate >= minDate && selectedDate <= maxDate
                          );
                        },
                        reevaluate: true,
                      },
                    ],
                  },
                  {
                    // screenField: "Supplier",
                    dataField: "SundryPaymentSupplierCode",
                    cssClass: "toolbar-customer-label",
                    label: {
                      text: "Supplier",
                    },
                    editorType: "dxSelectBox",
                    editorOptions: {
                      dataSource: SupplierService.dataSourceConfig(
                        "api/Supplier",
                        {
                          // select: ["Code", "Name"],
                          filter: this.getSupplierFilter,
                          sort: [{ selector: "Name", asc: true }],
                        },
                      ),
                      itemTemplate: (data) => {
                        return ` <div class="custom-auto-complete" id="${data.Code}" >
                            <span class="auto-complete-primary">
                              ${data.Name}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.Code}
                            </span> 
                          </div>`;
                      },
                      valueExpr: "Code",
                      displayExpr: "Name",
                      searchExpr: ["Code", "Name"],
                      searchMode: "contains",
                      showClearButton: true,
                      searchEnabled: true,
                      allowUpdate: true,
                      dropDownOptions: {
                        minWidth: 300,
                      },
                      placeholder: "Supplier Name",
                      onSelectionChanged:
                        this.onSupplierCodeValueChanged.bind(this),
                    },
                    searchExpr: ["Code", "Name"],
                    displayExpr: (e) => {
                      if (e) return `${e.Code} - ${e.Name}`;
                      else undefined;
                    },
                  },
                  {
                    screenField: "PayeeName",
                    dataField: "SundryPaymentPayeeName",
                    label: {
                      text: "Payee",
                    },
                    required: true,
                    editorOptions: {
                      allowUpdate: true,
                    },
                    defaultValue: this.PayeeName,
                  },
                  {
                    dataField: "Reference",
                    label: {
                      text: "Reference",
                    },
                    editorOptions: {
                      maxLength: 100,
                      allowUpdate: true,
                    },
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    itemType: "group",
                    caption: "",
                    colCount: 1,
                    items: [
                      {
                        dataField: "Narration",
                        label: {
                          text: "Narration",
                        },
                        editorType: "dxTextArea",
                        editorOptions: {
                          allowUpdate: true,
                          maxLength: 100,
                          height: 86,
                          onFocusOut: () => {
                            if (this.dataModel.DefaultComment) {
                              this.setAllEmptyCommentsItem();
                            }
                          },
                        },
                      },
                      {
                        dataField: "DefaultComment",
                        label: {
                          text: "Default Comment",
                        },
                        editorType: "dxCheckBox",
                        editorOptions: {
                          allowUpdate: true,
                          onValueChanged: (e) => {
                            if (e.value) {
                              this.setAllEmptyCommentsItem();
                            }
                          },
                        },
                      },
                    ],
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "SundryPaymentBASReportable",
                    label: {
                      text: "BAS Reportable",
                    },
                    cssClass: "myCss",
                    editorType: "dxCheckBox",
                    editorOptions: {
                      allowUpdate: true,
                    },
                  },
                  {
                    itemType: "group",
                    caption: "",
                    colCount: 2,
                    cssClass: "sundry-payment-amount-group",
                    items: [
                      {
                        screenField: "Currency",
                        displayExpr: "CurrencyCode",
                      },

                      {
                        screenField: "ExchangeRate",
                        cssClass: "remove-padding-bottom",
                        editorOptions: {
                          allowUpdate:
                            this.dataModel.CurrencyCode != this.currencyCode,
                          onValueChanged: async (e) => {
                            this.dataModel.ExchangeRate = e.value;
                            const items = await this.localDataSource.load();
                            items.forEach((element) => {
                              element.Amount = FxToBaseCurrency(
                                element.FxAmount,
                                e.value,
                              );
                            });

                            this.dataModel.SundryPaymentAmount =
                              this.dataModel.FxSundryPaymentAmount /
                              this.dataModel.ExchangeRate;
                            this.dataModel.SundryPaymentTax =
                              this.dataModel.FxSundryPaymentTax /
                              this.dataModel.ExchangeRate;
                            this.onSundryPaymentTaxChanged();
                          },
                        },
                      },
                      {
                        screenField: "FXAmount",
                        dataField: "FxSundryPaymentAmount",
                        format: "Decimal-16-2",
                        required: true,
                        label: {
                          text: `Amount (${this.dataModel.CurrencyCode})`,
                        },
                        editorOptions: {
                          allowUpdate: true,
                          onValueChanged: (e) => {
                            this.dataModel.FxSundryPaymentAmount = e.value;
                            this.dataModel.SundryPaymentAmount =
                              FxToBaseCurrency(
                                e.value,
                                this.dataModel.ExchangeRate,
                              );
                          },
                        },
                      },

                      {
                        screenField: "TaxTotal",
                        dataField: "FxSundryPaymentTax",
                        format: "Decimal-16-2",
                        required: false,
                        label: {
                          text: `Tax (${this.dataModel.CurrencyCode})`,
                        },
                        editorOptions: {
                          allowUpdate: true,
                          onValueChanged: ({ value }) => {
                            this.dataModel.FxSundryPaymentTax = value;
                            this.dataModel.SundryPaymentTax = FxToBaseCurrency(
                              value,
                              this.dataModel.ExchangeRate,
                            );

                            this.onSundryPaymentTaxChanged();
                          },
                          onKeyDown: (e) => {
                            this.tabIntoGrid(e);
                          },
                        },
                        cssClass: "remove-padding-bottom",
                      },

                      {
                        screenField: "FXAmount",
                        dataField: "SundryPaymentAmount",
                        format: "Decimal-16-2",
                        required: true,
                        visible:
                          this.dataModel.CurrencyCode != this.currencyCode,
                        label: {
                          text: `Amount (${
                            getDefaultUserSettings().CurrencyCode
                          })`,
                        },
                        editorOptions: {
                          // allowUpdate: true,
                          // onValueChanged: (e) => {
                          //   this.dataModel.SundryPaymentAmount = e.value;
                          //   this.dataModel.FxSundryPaymentAmount =
                          //     e.value * this.dataModel.ExchangeRate;
                          // },
                        },
                      },
                      {
                        screenField: "TaxTotal",
                        dataField: "SundryPaymentTax",
                        format: "Decimal-16-2",
                        required: false,
                        visible:
                          this.dataModel.CurrencyCode != this.currencyCode,
                        label: {
                          text: `Tax (${
                            getDefaultUserSettings().CurrencyCode
                          })`,
                        },
                        editorOptions: {
                          // allowUpdate: true,
                          // onValueChanged: ({ value }) => {
                          //   this.dataModel.SundryPaymentTax = value;
                          //   this.dataModel.FxSundryPaymentTax =
                          //     value * this.dataModel.ExchangeRate;
                          //   this.onSundryPaymentTaxChanged();
                          // },
                        },
                        cssClass: "remove-padding-bottom",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    popUpScreenOptions() {
      return [
        {
          value: "new-sundry-payment",
          text: "New Sundry Payment",
          isDefault: true,
        },
        {
          value: "new-sundry-receipt",
          text: "New Sundry Receipt",
          isDefault: false,
        },
      ];
    },
    async popUpScreenChangeCallback(e) {
      if (e && !e.event) return;
      if (this.isPopupHiddenBySave) {
        this.clearScreenData(e);
        this.isPopupHiddenBySave = false;
      } else if (this.isPopupHiddenByCancel) {
        this.clearScreenData(e);
        this.isPopupHiddenByCancel = false;
      } else {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave ?",
          "Unsaved Changes",
        );
        if (confirmLeaving) {
          this.clearScreenData(e);
        }
      }
    },
    async onSupplierCodeValueChanged(e) {
      let itemData = e.selectedItem; // For onSelectionChanged, use e.selectedItem to get the selected item data
      if (!itemData) {
        return;
      } else if (this.dataModel.SundryPaymentSupplierCode === itemData.Code) {
        return;
      }
      this.dataModel.SundryPaymentSupplierCode = itemData.Code;
      this.dataModel.SundryPaymentPayeeName = itemData.Name;

      this.dataModel.CurrencyCode = itemData.CurrencyCode;

      let currency = await ForeignCurrencyService.getByCode(
        itemData.CurrencyCode,
      );

      this.dataModel.ExchangeRate = currency.data.value[0].SellRate;

      this.dataModel.SundryPaymentAmount = FxToBaseCurrency(
        this.dataModel.FxSundryPaymentAmount,
        this.dataModel.ExchangeRate,
      );
      this.dataModel.SundryPaymentTax = FxToBaseCurrency(
        this.dataModel.FxSundryPaymentTax,
        this.dataModel.ExchangeRate,
      );
      this.onSundryPaymentTaxChanged();

      this.$nextTick(() => {
        this.setFocusOnField("SundryPaymentPayeeName");
      });
    },
    async onCustomerCodeValueChanged(e) {
      let itemData = e.selectedItem; // For onSelectionChanged, use e.selectedItem to get the selected item data
      if (!itemData) {
        return;
      }

      // Don't process if user is manually editing the Payer field
      if (this.isEditingPayerField) {
        return;
      }

      if (this.dataModel.SundryReceiptCustomerCode === itemData.Code) {
        return;
      }

      this.dataModel.SundryReceiptCustomerCode = itemData.Code;
      this.dataModel.SundryReceiptPayer = itemData.Name;

      this.dataModel.CurrencyCode = itemData.CurrencyCode;

      let currency = await ForeignCurrencyService.getByCode(
        itemData.CurrencyCode,
      );

      this.dataModel.ExchangeRate = currency.data.value[0].BuyRate;

      this.dataModel.SundryReceiptAmount = FxToBaseCurrency(
        this.dataModel.FxSundryReceiptAmount,
        this.dataModel.ExchangeRate,
      );
      this.dataModel.SundryReceiptTax = FxToBaseCurrency(
        this.dataModel.FxSundryReceiptTax,
        this.dataModel.ExchangeRate,
      );
      this.onSundryReceiptTaxChanged();

      this.$nextTick(() => {
        this.setFocusOnField("SundryReceiptPayer");
      });
    },
    async setGLChartDataSourceItems() {
      let branchDS = ProductService.dataSourceConfig("api/GLChart", {
        filter: [
          ["Inactive", "=", "N"],
          "and",
          ["Status", "=", "A"],
          "and",
          ["IsControlAcct", "<>", "Y"],
        ],
        sort: [{ selector: "ComputedStringCode", asc: true }],
        preventPagination: true,
      });
      this.glChartDataSourceItems = await branchDS.load();
    },
    async setDivisionDataSourceItems() {
      let divisionDS = DivisionService.dataSourceConfig("api/Division", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
        preventPagination: true,
        select: ["Code", "Description", "Inactive"],
      });
      this.divisionDataSourceItems = await divisionDS.load();
    },
    async setBranchDataSourceItems() {
      let branchDS = BranchService.dataSourceConfig("api/Branch", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
        preventPagination: true,
        select: ["Code", "Description", "Inactive"],
      });
      this.branchDataSourceItems = await branchDS.load();
    },
    async popupHidden() {
      var confirmLeaving = await this.$confirm(
        "You have unsaved changes. Are you sure you want to leave ?",
        "Unsaved Changes",
      );
      if (confirmLeaving) {
        this.gcSundryTransactionPopupConfig.gcPopupCallBack();
        if (this.isSundryPaymentScreen()) {
          this.clearSundryPaymentScreenData();
        } else {
          this.isPopupHiddenByCancel = true;
          this.loadDefaultScreen();
        }
      }
    },
    validateSundryPayment() {
      this.validateDate();
      this.validateSupplier();
      this.validatePayee();
      this.validateAmount();
    },
    validateSundryReceipt() {
      this.validateDate();
      this.validatePayee();
      this.validateAmount();
      this.validateCustomer();
      this.validatePaymentMethod();
      this.validateBranch();
      this.validateDivision();
    },
    async validateSundryPaymentGrid() {
      const items = await this.localDataSource.load();
      items.forEach((localItem) => {
        this.validateSundryPaymentAccount(localItem);
        this.validateSundryPaymentGridAmount(localItem);
        this.validateSundryPaymentGridBranch(localItem);
        this.validateSundryPaymentGridDivision(localItem);
      });
    },
    async validateSundryReceiptGrid() {
      const items = await this.localDataSource.load();
      items.forEach((localItem) => {
        this.validateSundryPaymentAccount(localItem);
        this.validateSundryPaymentGridAmount(localItem);
      });
    },
    validateSundryPaymentAccount(item) {
      if (item.GLChartCode == undefined) {
        this.validationSummary.push({ message: "Account feild is required" });
      }
    },
    validateSundryPaymentGridAmount(item) {
      if (item.Amount == undefined) {
        this.validationSummary.push({ message: "Amount feild is required" });
      }
    },
    validateSundryPaymentGridBranch(item) {
      if (item.BranchCode == undefined) {
        this.validationSummary.push({ message: "Branch feild is required" });
      }
    },
    validateSundryPaymentGridDivision(item) {
      if (item.DivisionCode == undefined) {
        this.validationSummary.push({ message: "Division feild is required" });
      }
    },
    validateSupplier() {
      if (this.isSundryPaymentScreen()) {
        if (this.dataModel.SundryPaymentSupplierCode == undefined)
          this.validationSummary.push({
            message: "Supplier field is required",
          });
      }
    },
    validateDate() {
      if (this.isSundryPaymentScreen()) {
        if (this.dataModel.SundryPaymentDate == undefined)
          this.validationSummary.push({ message: "Date field is required" });
      } else {
        if (this.dataModel.SundryReceiptDate == undefined)
          this.validationSummary.push({ message: "Date field is required" });
      }
    },
    validatePayee() {
      if (this.isSundryPaymentScreen()) {
        if (this.dataModel.SundryPaymentPayeeName == undefined)
          this.validationSummary.push({ message: "Payee field is required" });
      } else {
        if (this.dataModel.SundryReceiptPayer == undefined)
          this.validationSummary.push({ message: "Payer field is required" });
      }
    },
    validateAmount() {
      if (this.isSundryPaymentScreen()) {
        if (this.dataModel.SundryPaymentAmount == undefined)
          this.validationSummary.push({ message: "Amount field is required" });
      } else {
        if (this.dataModel.SundryReceiptAmount == undefined)
          this.validationSummary.push({ message: "Amount field is required" });
      }
    },
    validateCustomer() {
      if (this.dataModel.SundryReceiptCustomerCode == undefined)
        this.validationSummary.push({ message: "Customer feild is required" });
    },
    validatePaymentMethod() {
      if (this.dataModel.SundryReceiptPaymentMethod == undefined)
        this.validationSummary.push({
          message: "Payment Method feild is required",
        });
    },
    validateBranch() {
      if (this.dataModel.SundryReceiptBranch == undefined)
        this.validationSummary.push({ message: "Branch feild is required" });
    },
    validateDivision() {
      if (this.dataModel.SundryReceiptDivision == undefined)
        this.validationSummary.push({ message: "Division feild is required" });
    },

    onFormContentReady(e) {
      if (!e) return;

      if (e.component) {
        this.headerFormInstance = e.component;
      }

      this.$nextTick(() => {
        if (this.isBankAccountSelectionRequired) {
          this.focusBankAccountField();
        } else if (this.isSundryPaymentScreen()) {
          this.setFocusOnField("SundryPaymentDate");
        } else {
          this.setFocusOnField("SundryReceiptDate");
        }
      });
    },

    /**
     * Set Focus On Field
     * @param dataField
     */
    setFocusOnField(dataField) {
      if (this.headerFormInstance) {
        this.headerFormInstance.getEditor(dataField).focus();
      }
    },

    /**
     * Focus the title-area Bank Account selector. Used instead of the
     * Date field when the popup was opened without a bank account already
     * resolved (global entry points) — the selector lives outside the
     * gc-form instance, so it can't go through setFocusOnField().
     */
    focusBankAccountField() {
      if (this.$refs.bankAccountSelectBox) {
        this.$refs.bankAccountSelectBox.instance.focus();
      }
    },

    async tabIntoGrid(e) {
      if (!e.event) return;
      if (forwardTabbing(e)) {
        e.event.preventDefault();
        this.focusOnEditableCell(0);
      }
    },
  },
};
</script>

<style lang="scss">
.sundry-transaction-model {
  .header-form {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
  .footer-form {
    margin-top: 0 !important;
    display: flex;
    justify-content: flex-end;
    margin: 0 10px 10px 10px;
    background-color: white;
    border-radius: 3px;
  }
  .custom-title {
    margin-left: 50px;
  }
  .bank-account-selector {
    margin-left: 10px;
  }
  .title-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .footer {
    .save-btn {
      margin-right: 25px;
    }
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .dx-editor-cell.edit-cell-numberbox-field {
    padding: 5px !important;
  }

  .dx-datagrid-content td {
    vertical-align: top !important;
  }

  .sundry-payment-amount-group,
  .sundry-receipt-amount-group {
    .remove-padding-bottom {
      padding-bottom: 0 !important;
    }
  }
}
</style>
